import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Heading from '../../components/Heading';
import AboutHoldingSection from '../../components/AboutHoldingSection';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFilterData } from "../../actions/FiltersActions";
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadCompanies } from '../../actions/CompaniesActions';
import { loadScopeActivity } from '../../actions/ScopeActivityActions';
import { loadCities } from '../../actions/CitiesActions';
import { loadPersonal } from '../../actions/PersonalActions';
import PopularVacanciesBanner from '../../components/PopularVacanciesBanner';
import VideoBanner from '../../components/VideoBanner';
import Wealth from '../../components/Wealth';
import Conditions from '../../components/Conditions';
import Offices from '../../components/Offices';

class PageMain extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <div className="container container--indentVertical-xl container--noPaddinngHorizontal">
        <Helmet>
          <title>Работа в телекоммуникационной компании | Вакансии в ЭР-Телеком Холдинг в Перми</title>
          <meta name="description" content="Найдите вакансии в телекоммуникационной компании ЭР-Телеком Холдинг. Работа в Перми, карьерные возможности в сфере связи и технологий. Присоединяйтесь к нашей команде и развивайтесь с нами!" />
        </Helmet>
        <Heading/>
        <AboutHoldingSection/>
        <PopularVacanciesBanner/>
        <VideoBanner/>
        <Wealth/>
        <Conditions/>
        <Offices/>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
  }
}

const mapStateToProps = (state) => {
  return {
      vacancies: state.vacancies,
      companies: state.companies.list,
      scope_activity: state.scope_activity.list,
      hasErrored: state.vacancies.hasErrored || state.cities.hasErrored || state.companies.hasErrored,
      isLoading: state.vacancies.isLoading || state.cities.isLoading || state.companies.isLoading,
      filter: state.filter,
      cities: state.cities.list
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies, loadCompanies, loadScopeActivity, loadCities }, dispatch),
    handleChange: (val, label, type) => {
      dispatch(setFilterData(val, label, type))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageMain));



// WEBPACK FOOTER //
// ./src/pages/PageMain/index.js